import { useDispatch } from 'react-redux'
import moment from 'moment';

const DisparaMsj = (msj) => {
    const dispatch = useDispatch()
    dispatch({
        type: "TOAST_MSJ",
        payload: {
            cont: msj,
            tipo: "warning",
            time: moment().unix()
        },
    })
}

export class ConnectionError extends Error {
    constructor(message) {
        super(message);
        window.location.reload();
        console.log(message)
        console.log("Connection Error")
        this.name = "ConnectionError";
        DisparaMsj("ConnectionError")
    }
    /*
    console.error(error);
    return {
        type: SEND_USER_MSJ,
        msj: error,
        msj_tipo: "alert-danger",
    };
    */
}

export class ValidationError extends Error {
    constructor(message) {
        super(message);
        this.name = "ValidationError";
    }
}

export class AutenticateError extends Error {
    constructor(message) {
        super(message);
        this.name = "AutenticateError";
    }
}

/*
throw new ValidationError("No tiene nombre")

try {
}catch(e){
    if(e instanceof ConnectionError){
        setTimeout(()=>{
            // ejecuta de nuevo en 3 segundos
        }, "3000")
    }
    if(e instanceof ValidationError){
        // MUESTRA MODAL
    }
}
*/